import { Bouncer } from "../interfaces/Bouncer";

const parseBouncer = (): Bouncer => {
  const _tempData: any = {
    token: '',
  };
  try {
    const storageString = localStorage.getItem('bouncer');
    if (storageString) {
      const storageData = JSON.parse(storageString);
      Object.keys(_tempData).forEach(key => {
        if (storageData[key]) _tempData[key] = storageData[key];
      });
    }
  } finally {
    return _tempData;
  }
}

export default parseBouncer;